import { useQuery, useMutation, useQueryClient } from 'react-query';
import Api from '../../../../../shared/Api';
import { sendLink } from '../queries/updateMatterportLink';

const getOrder = (orderId) => {
    return new Api().get(`/views/orders/${orderId}`);
};

export const useOrderData = (orderId) => {
    return useQuery(['get-matterport-order', orderId], () => getOrder(orderId));
};

export const useAddLinkData = () => {
    const queryClient = useQueryClient();
    return useMutation(sendLink, {
        onSuccess: () => {
            queryClient.invalidateQueries('get-matterport-order');
        },
        onError: () => {}
    });
};
